import { render, staticRenderFns } from "./ClickAreaForShowResult.vue?vue&type=template&id=ff32b744&scoped=true"
import script from "./ClickAreaForShowResult.vue?vue&type=script&lang=ts"
export * from "./ClickAreaForShowResult.vue?vue&type=script&lang=ts"
import style0 from "./ClickAreaForShowResult.vue?vue&type=style&index=0&id=ff32b744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff32b744",
  null
  
)

export default component.exports